"use strict";
/** state: Final **/
/** family: NavBar **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var prop_types_1 = require("../../types/prop.types");
var Nav_1 = require("../Nav");
var utils_1 = require("../utils");
var CLASS_NAME = 'i-navbar';
var NavBarTheme;
(function (NavBarTheme) {
    NavBarTheme["Light"] = "light";
    NavBarTheme["Dark"] = "dark";
})(NavBarTheme = exports.NavBarTheme || (exports.NavBarTheme = {}));
/**
 * NavBar groups many components together to produce simple global navigation patterns.
 *
 * Patterns include text links, links with icons, notifications and dropdown menus.
 *
 * Also see {{Badge}}.
 */
var NavBar = /** @class */ (function (_super) {
    __extends(NavBar, _super);
    function NavBar(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Inject `navBar` prop into Nav children.
         */
        _this.injectPropsOnChildren = function () {
            return React.Children.map(_this.props.children, function (child) {
                if (utils_1.isType(child, Nav_1.Nav)) {
                    return React.cloneElement(child, {
                        isMobile: _this.state.isMobile,
                        navBar: true,
                    });
                }
                return child;
            });
        };
        _this.updateDimensions = function () {
            var isMobile = window.innerWidth < _this.props.mobileBreakPoint;
            if (_this.state.isMobile !== isMobile) {
                _this.setState({ isMobile: isMobile });
            }
        };
        _this.state = {
            isMobile: false,
        };
        return _this;
    }
    NavBar.prototype.UNSAFE_componentWillMount = function () {
        if (this.props.mobileBreakPoint) {
            this.updateDimensions();
        }
    };
    NavBar.prototype.componentDidMount = function () {
        if (this.props.mobileBreakPoint) {
            window.addEventListener('resize', this.updateDimensions);
        }
    };
    NavBar.prototype.componentWillUnmount = function () {
        if (this.props.mobileBreakPoint) {
            window.removeEventListener('resize', this.updateDimensions);
        }
    };
    NavBar.prototype.render = function () {
        var _a;
        var _b = this.props, fixedTop = _b.fixedTop, children = _b.children, className = _b.className, color = _b.color, theme = _b.theme, mobileBreakPoint = _b.mobileBreakPoint, restProps = __rest(_b, ["fixedTop", "children", "className", "color", "theme", "mobileBreakPoint"]);
        return (React.createElement("nav", __assign({ className: classNames(CLASS_NAME, className, 'navbar', 'navbar-expand-lg', (_a = {},
                _a[CLASS_NAME + "--mobile"] = mobileBreakPoint != null && this.state.isMobile,
                _a['fixed-top'] = fixedTop,
                _a["bg-" + color] = color != null,
                _a["navbar-" + theme] = theme != null,
                _a)) }, restProps), this.injectPropsOnChildren()));
    };
    NavBar.Color = prop_types_1.ThemeColor;
    NavBar.Theme = NavBarTheme;
    return NavBar;
}(React.Component));
exports.NavBar = NavBar;
//# sourceMappingURL=NavBar.js.map